document.addEventListener('DOMContentLoaded', () => {
  const swiperMain = setSwiperMain();
  const swiperFunc = setSwiperFunc();

  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1140,
    },
    toolSmoothScroll: {
      offsetSelector: '',
    },
  });

  UWX.MenuNext('.faq-list .heading');

  const startFire = document.documentElement.clientHeight / 2;
  UWX.ScrollActionReferPosition('.page_header', startFire, { activeClass: 'fixed' });
  UWX.ScrollActionReferPosition('.page-top', startFire);

});

const setSwiperMain = () => {
  return new Swiper('.sliderCase', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20, //px指定
    loopAdditionalSlides: 1,
    navigation: {
      nextEl: '.swiper-next_btn',
      prevEl: '.swiper-prev_btn'
    },
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    breakpoints: {
      321: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 50
      },
    },
  });
}

const setSwiperFunc = () => {
  return new Swiper('.sliderFunc', {
    loop: true,
    speed: 5000,
    slidesPerView: 'auto',
    spaceBetween: 40,
    direction: 'horizontal',
    freeMode: true,
    autoplay: {
      delay: 0,
      stopOnLast: false,
      disableOnInteraction: false
    },
    breakpoints: {
      321: {
        spaceBetween: 30
      },
      768: {
        spaceBetween: 40
      },
    },
  });
}
